export const exitSteps = [
  {
    id: 'step1',
    title: 'Step 1: Mark Employee on Notice',
    page: 'Employees',
    content: [
      'Navigate to the Employees page from the sidebar.',
      'Find the employee you want to put on notice.',
      'Click the warning triangle icon (Mark on Notice) in the Actions column.',
      'A dialog will open asking for:',
    ],
    details: [
      { label: 'Notice Start Date', desc: 'The date when the notice period officially begins.' },
      { label: 'Last Working Date (LWD)', desc: 'The last day the employee will be working. Must be after the Notice Start Date.' },
      { label: 'Reason', desc: 'Select a reason (e.g., Resignation, Termination).' },
    ],
    note: 'After saving, the employee will show an orange "ON NOTICE" badge with their LWD date on the Employees page.',
    important: 'Notice Start Date cannot be after Last Working Date. The system will reject invalid dates.',
  },
  {
    id: 'step2',
    title: 'Step 2: Salary Entry — "Do Not Pay" for Notice Months',
    page: 'Salary Entry',
    content: [
      'Navigate to the Salary Entry page.',
      'For months within the notice period (Notice Start Month to LWD Month):',
    ],
    details: [
      { label: 'NOTICE Badge', desc: 'An orange "NOTICE" badge appears next to the employee name.' },
      { label: 'Do Not Pay', desc: 'The "Paid" checkbox is replaced with a "DO NOT PAY" badge.' },
      { label: 'KPI Strip', desc: 'An orange "Notice Period" banner shows at the top: On Notice count, Frozen Salary, and a link to View Settlements.' },
    ],
    note: 'For months outside the notice period, the employee appears normally with a regular "Paid" checkbox.',
    important: 'The frozen salary is NOT lost — it will be settled through the Resigned Employees page.',
  },
  {
    id: 'step3',
    title: 'Step 3: Generate Settlement Record',
    page: 'Resigned Employees',
    content: [
      'Navigate to the Resigned Employees page from the sidebar.',
      'Select the settlement month and year (usually the LWD month).',
      'Click "Generate Monthly" to create the settlement record.',
    ],
    details: [
      { label: 'Days Worked', desc: 'Calculated from Notice Start Date to LWD within the selected month.' },
      { label: 'LOP Days', desc: 'Total days in month minus Days Worked.' },
      { label: 'Pro-rated Salary', desc: 'Salary based on days actually worked (after Retention Bonus deduction).' },
    ],
    note: 'A collapsible card will appear showing: employee name, notice dates, days worked, and Bank Transfer amount.',
  },
  {
    id: 'step4',
    title: 'Step 4: Review & Edit Settlement Breakdown',
    page: 'Resigned Employees',
    content: [
      'Click on the employee card to expand it. You will see three columns:',
    ],
    details: [
      { label: 'Previous Month (Read-only)', desc: 'Previous month Gross Salary, LOP Days, Net Paid, and Status.' },
      { label: 'Current Month', desc: 'Gross, Retention Bonus, Net Eligible, Days Worked, LOP Days, Pro-rated Salary.' },
      { label: 'Settlement Breakdown', desc: 'All notice period months summed, plus editable fields.' },
    ],
    note: null,
  },
  {
    id: 'step5',
    title: 'Step 5: Enter Settlement Amounts',
    page: 'Resigned Employees',
    content: [
      'In the Settlement Breakdown column, you can edit:',
    ],
    details: [
      { label: '+ Reward', desc: 'Any reward or bonus amount to be paid.' },
      { label: '+ Retention Payable', desc: 'Retention amount to be released to the employee.' },
      { label: '- Recovery Amount', desc: 'Amount to recover (laptop, advance, notice shortfall). Click "Save Recovery" after entering.' },
      { label: '- Income Tax', desc: 'Click "Set IT" to configure tax deduction (Fixed or Percentage).' },
    ],
    note: 'Bank Transfer = Total Notice Salary + Reward + Retention - Recovery - Income Tax',
    important: 'If Bank Transfer is negative, the "Paid" checkbox is replaced with a "DO NOT PAY" badge.',
  },
  {
    id: 'step6',
    title: 'Step 6: Add Follow-up Comments',
    page: 'Resigned Employees',
    content: [
      'Below the settlement breakdown, click "Follow-up Comments" to expand the section.',
    ],
    details: [
      { label: 'Add a note', desc: 'Type in the input and press Enter or click send.' },
      { label: 'Audit trail', desc: 'Each comment shows author name, role badge, and timestamp.' },
      { label: 'Examples', desc: '"Recovery confirmed by HR", "Laptop returned", "IT clearance pending".' },
    ],
    note: 'Comments are visible to all authorized users and serve as a permanent audit trail.',
  },
  {
    id: 'step7',
    title: 'Step 7: Finalize Settlement',
    page: 'Resigned Employees',
    content: [
      'Once all amounts are correct, check the "Finalized" checkbox in the footer.',
    ],
    details: [
      { label: 'Fields Lock', desc: 'All editable fields become read-only. No changes allowed.' },
      { label: 'Employee Status', desc: 'Status changes from "On Notice" to "Exited". Excluded from future salary.' },
      { label: 'EXITED Badge', desc: 'Employees page shows a gray "EXITED" badge.' },
    ],
    note: null,
    important: 'To revert: Super Admin unchecks "Finalized" — status goes back to "On Notice" and fields unlock.',
  },
  {
    id: 'step8',
    title: 'Step 8: Re-hire (Optional)',
    page: 'Employees',
    content: [
      'If an exited employee needs to be brought back:',
    ],
    details: [
      { label: 'Find the employee', desc: 'Employees page — look for the gray "EXITED" badge.' },
      { label: 'Click Re-hire', desc: 'Green checkmark icon in the Actions column.' },
      { label: 'Confirm', desc: 'Confirmation dialog appears. Click "Re-hire" to set back to "Active".' },
    ],
    note: 'After re-hire, the employee returns to normal salary generation. All notice dates are cleared.',
  },
];
